const OFFER_PREVIEW_ID_KEY = "uso_preview";
const OFFER_PREVIEW_NAME_KEY = "n";
const OFFER_PREVIEW_SESSION_KEY = "uso_offer_preview_s";

module.exports = {
  OFFER_PREVIEW_ID_KEY,
  OFFER_PREVIEW_NAME_KEY,
  OFFER_PREVIEW_SESSION_KEY
};
